import { Component, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { EnvService } from "../env.service";
import { DataExportService } from "../shared/services/data-export.service";
import { ModalService } from "./../shared/services/modal.service";
import { UserService } from "./../shared/services/user.service";

import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-navbar",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent {
  @Input() groupName: string;
  @Input() groupId: string;
  isCitoEmployee: boolean;
  username: string;
  showResetOption = false;
  userName: string;
  downloadGroeimeterData: FormGroup;
  downloadUsageData: FormGroup;
  vanafdate: string;
  totdate: string;

  pwdPattern = "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,60}$";
  schoolyearPattern = "([0-9]{4})(-{1})([0-9]{4})$";
  yearPattern = "^[0-9]{4}$";
  weekPattern = "^[0-9]{2}$";

  constructor(
    private userService: UserService,
    private env: EnvService,
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private dataExportService: DataExportService,
    private router: Router
  ) {
    this.username = userService.user.name;
    this.isCitoEmployee = userService.user.isCitoEmployee;
    this.showResetOption = this.env.demomode;
    this.downloadGroeimeterData = new FormGroup({
      schooljaar: new FormControl("", [
        Validators.required,
        Validators.pattern(this.schoolyearPattern),
      ]),
      wachtwoord: new FormControl("", Validators.pattern(this.pwdPattern)),
    });

    this.downloadUsageData = new FormGroup({
      // jaar: new FormControl('', [Validators.required, Validators.pattern(this.yearPattern)]),
      // week: new FormControl('', [Validators.required, Validators.pattern(this.weekPattern)]),
      vanaf: new FormControl("", Validators.required),
      tot: new FormControl("", Validators.required),
      wachtwoord2: new FormControl("", Validators.pattern(this.pwdPattern)),
    });
  }

  get isDashboard() {
    return this.router.url === "/dashboard";
  }

  get schooljaar() {
    return this.downloadGroeimeterData.get("schooljaar");
  }
  get wachtwoord() {
    return this.downloadGroeimeterData.get("wachtwoord");
  }

  // get jaar() { return this.downloadUsageData.get('jaar'); }
  // get week() { return this.downloadUsageData.get('week'); }
  get vanaf() {
    return this.downloadUsageData.get("vanaf");
  }
  get tot() {
    return this.downloadUsageData.get("tot");
  }
  get wachtwoord2() {
    return this.downloadUsageData.get("wachtwoord2");
  }

  onSubmitGroeimeter(data: any) {
    this.downloadGroeimeterData.reset();
    console.warn("Your form has been submitted");
    this.dataExportService.getGroeimeterData(data.schooljaar, data.wachtwoord);
  }

  onSubmitUsage(data: any) {
    this.downloadUsageData.reset();
    console.warn("Your form has been submitted");
    this.dataExportService.getUsageData(data.vanaf, data.tot, data.wachtwoord2);
  }

  logout = () => this.userService.logout();

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }
}
